export enum ScanStatus {
  LOADING = 'LOADING',
  REDIRECTING = 'REDIRECTING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}
